import {ScoringSystemFacets, ScoringSystemId} from '../interfaces/FormValues';

export default function processScoringSystems(
  scoringSystems: Record<ScoringSystemId, ScoringSystemFacets>
) {
  return Object.keys(scoringSystems).map((scoringSystemKey) => ({
    scoringSystem: scoringSystemKey,
    scoringSystemFacets: Object.keys(scoringSystems[scoringSystemKey]).map(
      (scoringSystemFacetId) => ({
        scoringSystemFacet: scoringSystemFacetId,
        value: scoringSystems[scoringSystemKey][scoringSystemFacetId] ?? ''
      })
    )
  }));
}
